var exports = {
  "IW": "TypingUsers.module__typing___RnVfek",
  "Xh": "TypingUsers.module__username___RnVfek",
  "V": "TypingUsers.module__composerStatus___RnVfek",
  "sM": "TypingUsers.module__srOnly___RnVfek",
  "xP": "TypingUsers.module__measure___RnVfek",
};

module.exports = exports;
